import type { ReactNode } from 'react'
import { CheckCircle2 } from 'lucide-react'
import { cn } from '@/shared/lib/utils'
import { toneSoftClass } from './tone'

export function ConfirmationPanel({
  title,
  description,
  referenceLabel,
  reference,
  nextStep,
  details,
  action,
  className,
}: {
  title: string
  description?: string
  referenceLabel?: string
  reference?: string
  nextStep?: string
  details?: ReactNode
  action?: ReactNode
  className?: string
}) {
  return (
    <section className={cn('rounded-lg border p-5 text-foreground', toneSoftClass.ok, className)} aria-live="polite">
      <div className="flex gap-3">
        <CheckCircle2 className="mt-0.5 size-5 shrink-0 text-[var(--v2-ok)]" aria-hidden />
        <div className="min-w-0">
          <h2 className="font-display text-base font-semibold">{title}</h2>
          {description ? <p className="mt-1 text-sm text-muted-foreground">{description}</p> : null}
          {reference && referenceLabel ? (
            <p className="mt-3 text-sm">
              <span className="font-medium">{referenceLabel}</span> <span>{reference}</span>
            </p>
          ) : null}
          {nextStep ? <p className="mt-2 text-sm text-muted-foreground">{nextStep}</p> : null}
          {details ? <div className="mt-3 text-sm">{details}</div> : null}
          {action ? <div className="mt-4">{action}</div> : null}
        </div>
      </div>
    </section>
  )
}
